export default __webpack_public_path__ + "static/media/payroll-icon.e5fde4d2.svg";